import React from 'react';
import './Pulsar.css';

const VideoYouTube = ({ id, titulo = "Vídeo de YouTube" }) => {
  return (
    <div className="video-wrapper">
      {/* Contenedor de la pantalla */}
      <div className="video-container-inner">
        <iframe
          src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
          title={titulo}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Panel de botones de la derecha */}
      <div className="tv-controls">
        <div className="tv-button"></div>
        <div className="tv-button"></div>
        <div className="tv-grill"></div>
        <div className="tv-button" style={{backgroundColor: '#900'}}></div> {/* Botón ON/OFF */}
      </div>
    </div>
  );
};

export default VideoYouTube;